/**
 * Exhaustive guard for switch statements with discriminated unions
 * When used in default case, this will type error if a case is missing
 * @param value Value of switch case that should not be reached
 */
export const exhaustiveGuard = (value: never): never => {
    throw new Error(`Unexpected value: ${value}`);
};
